function isValidEmail(email: string): boolean {
  const trimEmail = email ? email.trim() : ''
  const emailRegex = /^([\w-+]+(?:\.[\w-+]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)(?:\s)*$/i

  return emailRegex.test(trimEmail)
}

export default isValidEmail
